import { DatabaseModel, ModelJson } from "./database-model";

/**
 * API and app integration access rights
 */
export class AccessRights extends DatabaseModel {
    /**
     * Key (world/project key)
     */
    key: string = '';

    /**
     * API key to access the StoryHunt API
     */
    apiKey: string = '';

    /**
     * Associated project key
     */
    project: string = '';

    /**
     * Customer specific StoryHunt app integration key used in apps integrating StoryHunt
     */
    appIntegrationId: string = '';

    constructor(json?: ModelJson, key?: string) {
        super(json, key);
        if(json) this.fromJson(json);
        if(key) this.key = key;
    }

    public fromJson(json: ModelJson) {
        // Extract member variables from json
        let obj = DatabaseModel.extract(json as AccessRights, ["project", "apiKey", "appIntegrationId"]);
        // Assign to this object
        Object.assign(this, obj);
    }

    public toJson(): ModelJson {
        let json = Object.assign({}, this);
        return json;
    }

    public generateApiKey() {
        return "sh-api-" + this.genKey();
    }

    public generateIntegrationKey() {
        return "sh-app-" + this.genKey();
    }

    /**
     * Generate new access right keys
     */
    public init(projectKey: string): AccessRights {
        this.key = projectKey;
        this.project = projectKey;
        this.apiKey = this.generateApiKey();
        this.appIntegrationId = this.generateIntegrationKey();
        return this;
    }
}
